export default __webpack_public_path__ + "static/media/card6.0ed58964.png";